// Size Chart

document.addEventListener('DOMContentLoaded', () => {
  const sizeChartElement = document.getElementById('size-chart');

  if (!sizeChartElement) return;

  const allSizes = sizeChartElement.textContent;
  const sizeSetArray = allSizes.split('|');

  const sizeChartTableHeader = `
    <header>
      <p class="measurement-selector">
        <a data-href="#centimetres" class="exclude-hover-underline-animation current hover-underline-animation--active">Cms</a>
        <span class="size-pipe">|</span>
        <a data-href="#inches" class="exclude-hover-underline-animation">Inches</a>
      </p>
      <div class="clearfix"></div>
    </header>
    <div class="table-scroll">
      <div class="rte__table-wrapper">
        <table class="measurements responsive">
          <thead>
            <tr>
              <th class="fixed-side">SIZE</th>
              <th class="odd">SMALL<br><span class="ausie-size">(AU 8)</span></th>
              <th class="even">MEDIUM<br><span class="ausie-size">(AU 10)</span></th>
              <th class="odd">LARGE<br><span class="ausie-size">(AU 12)</span></th>
              <th class="even">XL<br><span class="ausie-size">(AU 14)</span></th>
              <th class="odd">XXL<br><span class="ausie-size">(AU 16)</span></th>
            </tr>
          </thead>
  `;

  const generateTableBody = (unit) => {
    const rows = sizeSetArray.map((sizeSet) => {
      const sizeArray = sizeSet.split(',');
      const cells = sizeArray.map((value, index) => {
        const className = `${index % 2 === 0 ? 'even' : 'odd'}${index === 0 ? ' fixed-side' : ''}`;
        let cellValue = value;

        if (unit === 'inches' && index !== 0) {
          cellValue = (Math.round((value / 2.54) * 100) / 100).toFixed(2);
        }

        return `<td class="${className}">${cellValue}</td>`;
      });

      return `<tr>${cells.join('')}</tr>`;
    });

    return `<tbody class="${unit}" style="${unit === 'centimetres' ? '' : 'display:none;'}">
              ${rows.join('')}
            </tbody>`;
  };

  const sizeChartTable = `
    ${sizeChartTableHeader}
    ${generateTableBody('centimetres')}
    ${generateTableBody('inches')}
          </table>
        </div>
      </div>
  `;

  // Insert the generated table after the #size-chart element
  sizeChartElement.insertAdjacentHTML('afterend', sizeChartTable);

  const THEAD_HEIGHT = 96;
  const TR_HEIGHT = 52;
  const tableHeight = sizeSetArray.length * TR_HEIGHT + THEAD_HEIGHT;

  const measurementsImage = document.querySelector('.measurements-wrapper img');
  if (measurementsImage) {
    measurementsImage.style.marginTop = `${tableHeight}px`;
  }

  // Measurement selector functionality
  const measurementLinks = document.querySelectorAll('.measurement-selector a');
  const tbodies = document.querySelectorAll('table.measurements tbody');

  measurementLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      // Remove 'current' class from all links
      measurementLinks.forEach((otherLink) => {
        otherLink.classList.remove('current', 'hover-underline-animation--active');
      });

      // Add 'current' class to the clicked link
      link.classList.add('current', 'hover-underline-animation--active');

      // Hide all tbodies
      tbodies.forEach((tbody) => {
        tbody.style.display = 'none';
      });

      // Show the selected unit tbody
      const unit = link.getAttribute('data-href').substring(1);
      const tbodyToShow = document.querySelector(`table.measurements tbody.${unit}`);
      if (tbodyToShow) {
        tbodyToShow.style.display = '';
      }
    });
  });
});
